export const locale = {
    lang: 'es',
    data: {
        ORDER_CLINIC_MESSAGE: {
            TITLE: 'Chat',
            EMPTY: 'Ningún mensaje',
            ORDER_FINISHED: 'Pedido finalizado',
            ERROR_USER_LOGGED_EQUAL_CUSTOMER: 'No está permitido enviar mensajes a usted mismo',
            FORM: {
                FIELDS: {
                    MESSAGE: 'Escribe tu mensaje',
                },
            },
            MAT_MENU: {
                FILES: 'Archivos',
                PHOTOS_AND_VIDEOS: 'Fotos y videos',
            },
            TOASTR: {
                ERRORS: {
                    PHOTO_VIDEO: 'Solo se permiten imágenes o videos.',
                    FILE: 'Solo se permiten archivos que no sean imágenes o videos.',
                    MAX_FILE: 'Se permiten un máximo de 15 archivos.',
                    MAX_FILE_SIZE: 'No se permite la carga de archivos de más de 150 MB.',
                },
            },
            MODAL: {
                GENERAL: {
                    BUTTONS: {
                        CONFIRM: 'Enviar',
                        CANCEL: 'Cancelar',
                    },
                },
                PREVIEW: {
                    TITLE: 'Vista previa',
                },
                IMAGE: {
                    TITLE: 'Ver imagen',
                },
            },
            DROPZONE: {
                DESCRIPTION: 'Suelta los archivos para cargar',
            },
        },
    },
};
